const GUEST_PROFILE_KEY = "tmrx_guest_profile";

export const saveGuestProfileLocal = (profile) => {
  if (!profile) {
    return;
  }
  localStorage.setItem(GUEST_PROFILE_KEY, JSON.stringify(profile));
};

export const getGuestProfileLocal = () => {
  try {
    const raw = localStorage.getItem(GUEST_PROFILE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearGuestProfileLocal = () => {
  localStorage.removeItem(GUEST_PROFILE_KEY);
};

export const applyGuestProfileToLogin = (loginData, profile) => {
  if (!loginData?.user || !profile) {
    return loginData;
  }

  const firstname = profile.firstname?.trim() || "";
  const lastname = profile.lastname?.trim() || "";
  const licenseNumber = profile.licenseNumber?.trim() || "";

  return {
    ...loginData,
    user: {
      ...loginData.user,
      firstname,
      lastname,
      licenseNumber,
      fullName: `${firstname} ${lastname}`.trim(),
    },
  };
};

export const buildPharmacistActionPayload = (user) => {
  const localProfile = getGuestProfileLocal();
  const firstname = localProfile?.firstname?.trim() || "";
  const lastname = localProfile?.lastname?.trim() || "";
  const localFullName = `${firstname} ${lastname}`.trim();
  const localLicense = localProfile?.licenseNumber?.trim() || "";

  const pharmacistFullName =
    localFullName || user?.fullName?.trim() || "";
  const pharmacistLicenseNumber =
    localLicense || user?.licenseNumber?.trim() || "";

  if (!pharmacistFullName && !pharmacistLicenseNumber) {
    return {};
  }

  return {
    changeStatusBy: pharmacistFullName || undefined,
    pharmacistData: {
      pharmacistFullName: pharmacistFullName || undefined,
      pharmacistLicenseNumber: pharmacistLicenseNumber || undefined,
    },
  };
};
